import React from 'react';
import { Content, ModalLayout, Text } from 'components';
import { Button, Flex, Image, Input } from 'antd';
import Formatter from 'utils/Formatter';
import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import MessageAlert, { STORE_URL } from 'utils';

const BusinessModal = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const {
    isOpened = false,
    onClose,
    isLoading = false,
    onSubmit,
    defaultData = null,
  } = props;

  /* ===== State ===== */
  const fileRef = React.useRef(null);
  const [businessNum, setBusinessNum] = React.useState('');
  const [businessFile, setBusinessFile] = React.useState(null);

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /**
   * 파일 선택 핸들러
   * --
   * @param {File} files
   * @returns
   */
  const fileChange = (files) => {
    if (!files || !files.length) return;

    setBusinessFile(files[0]);
  };

  /**
   * 사업자 회원 신청 유효성 검사
   * @returns
   */
  const validateCheck = async () => {
    if (!businessNum) {
      MessageAlert.info('사업자 번호를 입력해주세요!');
      return;
    }

    if (businessNum.length !== 12) {
      MessageAlert.info('사업자 번호를 확인해주세요!');
      return;
    }

    if (!businessFile) {
      MessageAlert.info('사업자 등록증 파일을 업로드해주세요!');
      return;
    }

    let res = true;
    if (onSubmit) {
      res = await onSubmit(
        businessNum,
        businessFile,
        defaultData ? 'update' : 'create'
      );
    }

    if (res) {
      setBusinessNum();
      setBusinessFile();
      onClose();
    }
  };

  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  React.useEffect(() => {
    if (!defaultData) return;

    const { businessNum: bizNum, businessFile: bizFile } = defaultData;

    setBusinessNum(bizNum);
    setBusinessFile(bizFile);
  }, [defaultData]);

  /* ===== Render ===== */
  return (
    <ModalLayout
      type="modal"
      title={'사업자 인증'}
      open={isOpened}
      onCancel={onClose}
      width={500}
      centered
      closable
      loading={isLoading}
      footer={
        <Flex>
          <Button
            size="large"
            type="primary"
            style={{ marginTop: 20, width: '100%' }}
            onClick={() => validateCheck()}
          >
            {defaultData ? '수정하기' : '신청하기'}
          </Button>
        </Flex>
      }
    >
      <Content maxWidth={'100%'} padding={'10px 0px 20px'}>
        <Text size={12} color={'#D33444'} style={{ paddingBottom: 10 }}>
          사업자 인증을 받으시고 구매 시 혜택을 받아보세요!
        </Text>

        <Flex vertical gap={10}>
          <Input
            value={businessNum}
            onChange={(e) =>
              setBusinessNum(Formatter.hyphen(e.target.value, 'business_num'))
            }
            placeholder="사업자번호를 입력해주세요"
            maxLength={12}
          />

          {!businessFile ? (
            <Button
              icon={<UploadOutlined />}
              onClick={() => fileRef.current.click()}
            >
              사업자 등록증 업로드
              <input
                ref={fileRef}
                type="file"
                style={{ display: 'none' }}
                onChange={(e) => fileChange(e.target.files)}
                accept="image/*"
              />
            </Button>
          ) : (
            <Flex align="center" gap={4}>
              <Image
                src={
                  typeof businessFile === 'string'
                    ? `${STORE_URL}/${businessFile}`
                    : URL.createObjectURL(businessFile)
                }
                alt="사업자등록증"
                width={150}
                height={250}
              />

              <Button
                danger
                icon={<DeleteOutlined />}
                onClick={() => setBusinessFile(null)}
              />
            </Flex>
          )}
        </Flex>
      </Content>
    </ModalLayout>
  );
};

export default BusinessModal;
